module.exports = __webpack_public_path__ + "static/media/logojamirabrancopetroleo.424fa107.png";